/* SUPERNETIC theme — global interactions
   Cart drawer, mobile menu, qty controls, variant pickers, scroll animations.
*/
(function () {
  'use strict';

  // ----- mobile menu -----------------------------------------------------
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ----- cart drawer -----------------------------------------------------
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openers.forEach(el => el.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  closers.forEach(el => el.addEventListener('click', (e) => { e.preventDefault(); closeCart(); }));
  overlay && overlay.addEventListener('click', closeCart);

  // ----- qty steppers ----------------------------------------------------
  document.querySelectorAll('.product-form__qty').forEach(qty => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    qty.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // ----- variant pickers -------------------------------------------------
  document.querySelectorAll('[data-option-group]').forEach(group => {
    const pills = group.querySelectorAll('.option-pill');
    pills.forEach(p => {
      p.addEventListener('click', () => {
        pills.forEach(x => x.setAttribute('aria-checked', 'false'));
        p.setAttribute('aria-checked', 'true');
      });
    });
  });

  // ----- async add to cart ----------------------------------------------
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submit = form.querySelector('[type=submit]');
      const originalText = submit ? submit.textContent : '';
      if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        form.submit();
      } finally {
        if (submit) { submit.disabled = false; submit.textContent = originalText; }
      }
    });
  });

  async function refreshCart() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await r.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const drawerItems = document.querySelector('.cart-drawer__items');
      if (drawerItems) {
        if (!cart.items.length) {
          drawerItems.innerHTML = '<p class="muted" style="padding:40px 0;text-align:center;">Your cart is empty.</p>';
        } else {
          drawerItems.innerHTML = cart.items.map(line => `
            <div class="cart-line">
              <img src="${line.image || ''}" alt="${line.product_title}">
              <div>
                <div class="cart-line__title">${line.product_title}</div>
                <div class="cart-line__variant">${line.variant_title || ''}</div>
                <div class="muted" style="font-size:13px;margin-top:6px;">Qty ${line.quantity}</div>
              </div>
              <div>${formatMoney(line.final_line_price)}</div>
            </div>
          `).join('');
        }
      }
      const totalEl = document.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    } catch (e) { console.error(e); }
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // initial cart count refresh
  refreshCart();

  // ----- scroll-in animations -------------------------------------------
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-animate]').forEach(el => io.observe(el));
  }
})();
